export const initialFormValues = {
  clientName: '',
  clientType: '',
  dateOfBilling: '',
  serviceDescription: '',
  grossUnitValue: '',
  totalQuantity: '',
  grossTotalValue: '',
  tax: '',
  netTotalValue: '',
  observations: '',
  filiCode: '',
  clientCode: '',
  competenceDate: ''
}
